import React from 'react';
import Slider from '@mui/material/Slider';
import { getEmbedParentOrigin } from '../../utils/embedBridge';

/**
 * Drop-in for MUI <Slider> that renders a NATIVE range input inside the
 * Premiere panel — CEF fumbles MUI's pointer-capture drags (the Video
 * Width / search-context sliders wouldn't drag), while native ranges are
 * handled by the browser itself. Everywhere else it IS the MUI Slider.
 * Supports the single-value API subset we use (value, min/max/step,
 * onChange(e, v), onChangeCommitted(e, v)); marks/valueLabel are dropped
 * in panel mode (surrounding labels already show the value).
 */
const IS_PANEL_EMBED = typeof window !== 'undefined' && getEmbedParentOrigin() === 'file://';

const PanelSlider = (props) => {
    if (!IS_PANEL_EMBED || Array.isArray(props.value)) {
        return <Slider {...props} />;
    }
    const { value, min = 0, max = 100, step = 1, onChange, onChangeCommitted, disabled } = props;
    const fire = (cb) => (e) => { if (cb) cb(e, Number(e.target.value)); };
    return (
        <input
            type="range"
            value={typeof value === 'number' ? value : 0}
            min={min}
            max={max}
            step={step}
            disabled={disabled}
            onChange={fire(onChange)}
            onMouseUp={fire(onChangeCommitted)}
            onTouchEnd={fire(onChangeCommitted)}
            onKeyUp={fire(onChangeCommitted)}
            style={{ width: '100%', height: 22, accentColor: '#e0245e', cursor: 'pointer' }}
        />
    );
};

export default PanelSlider;
